var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parseQuery, getAppType } from '../../utils/index';
// tea参数默认值
var BE_NULL = 'be_null';
// 地理位置信息
var HAS_FETCHED_GEO = false;
var HAS_START_FETCH_GEO = false;
var geoInfo = {
    city: BE_NULL,
    continent: BE_NULL,
    country: BE_NULL,
    subdivisions: BE_NULL,
};
var isNode = typeof window === 'undefined';
// app_id
var HAS_INITED_APP_ID = false;
var APP_ID = (function () {
    // 如是在红砖模版，直接取window.runtime
    if (!isNode && window.runtime) {
        var appId = window.runtime.appId;
        HAS_INITED_APP_ID = true;
        return appId;
    }
    // 如果在game-tool-cli模版，没有预留占位符，需要用户初始化
    return null;
})();
// activity_id
var HAS_INITED_ACTIVITY_ID = false;
var ACTIVITY_ID = (function () {
    // 如是在红砖模版，直接取window.runtime
    if (!isNode && window.runtime) {
        var actId = window.runtime.actId;
        HAS_INITED_ACTIVITY_ID = true;
        return actId;
    }
    // 如果在game-tool-cli模版，没有预留占位符，需要用户初始化
    return null;
})();
// 区域
var AREA_SIGNAL = 'cn';
var DEFAULT_DATA = {};
// URL query参数
var QUERY = (function () {
    return isNode ? Object.create(null) : parseQuery();
})();
// event_id
var RANDOM_CHARS = '0123456789abcdefghijkABCDEFGHIJK';
var genRandomStr = function (length) {
    var re = '';
    var charLen = RANDOM_CHARS.length;
    for (var i = 0; i < length; i++) {
        re += RANDOM_CHARS[Math.floor(Math.random() * charLen)];
    }
    return re;
};
var EVENT_ID = genRandomStr(32) || '';
// get session_id
var getSessionId = function () {
    var sessionid = sessionStorage.getItem('SESSION_ID');
    if (!sessionid) {
        sessionid = genRandomStr(32);
        sessionStorage.setItem('SESSION_ID', sessionid);
    }
    return sessionid;
};
// 获取页面打开来源
var LAUNCH_FROM;
// 系统
var OS;
var getOS = function () {
    if (/iPhone/i.test(navigator.userAgent)) {
        return 'ios';
    }
    else if (/Android/i.test(navigator.userAgent)) {
        return 'android';
    }
    else {
        return 'pc';
    }
};
// 是否初始化header头信息
var HAS_CONFIG_CUS_HEADER = false;
var getCustomsHeader = function () {
    // 1. 正式环境：environment ='product'
    // 2. 沙箱环境：environment ='sandbox'
    // 3. BOE正式环境：environment ='boe-product'
    // 4. BOE沙箱环境：environment ='boe-sandbox'
    var hostname = location.hostname;
    if (hostname.indexOf('boe-act.bytedance.net') > -1) {
        return 'boe-sandbox';
    }
    if (hostname.indexOf('boe-act-internal.bytedance.net') > -1) {
        return 'boe-product';
    }
    if (hostname.indexOf('.bytedance.net') > -1 ||
        hostname.indexOf('sandbox') > -1 ||
        hostname.indexOf('localhost') > -1) {
        return 'sandbox';
    }
    return 'product';
};
var defaultLogMessageFn = function (event, params) {
    params = params || {};
    console.log('');
    console.log('========= 埋点上报 =========');
    console.log('上报时间：', new Date().toLocaleString());
    console.log('事件名称：', event);
    console.log('事件参数：', JSON.stringify(params, null, 2));
    console.log('');
};
var preInstallTeaSdk = function (zone) {
    return new Promise(function (resolve) {
        var teaPre = document.createElement('script');
        var teaSdk = document.createElement('script');
        teaPre.innerHTML = "\n      (function (win, export_obj) {\n        win['TeaAnalyticsObject'] = export_obj;\n        if (!win[export_obj]) {\n          function _collect() {\n            _collect.q.push(arguments);\n          }\n          _collect.q = _collect.q || [];\n          win.TEA = win[export_obj] = _collect;\n        }\n        win[export_obj].l = +new Date();\n      })(window, 'collectEvent');\n    ";
        teaSdk.src =
            zone === 'cn'
                ? 'https://lf1-cdn-tos.bytescm.com/obj/static/log-sdk/collect/collect.js'
                : 'https://sf16-scmcdn-sg.ibytedtos.com/obj/static-sg/log-sdk/collect/collect.js'; // sg
        // va:https://sf16-scmcdn-va.ibytedtos.com/obj/static-us/log-sdk/collect/collect.js
        document.body.appendChild(teaPre);
        setTimeout(function () {
            document.body.appendChild(teaSdk);
        }, 50);
        setTimeout(function () {
            resolve(true);
        }, 100);
    });
};
var startTime = 0;
// 初始化APP_ID，ACTIVITY_ID
export var initSendLogV3 = function (_a) {
    var app_id = _a.app_id, activity_id = _a.activity_id, _b = _a.default_data, default_data = _b === void 0 ? {} : _b, zone = _a.zone;
    if (!zone) {
        throw new Error('gameSDK.Tea.initSendLogV3:\n初始化缺少zone(区域)字段，请根据业务地区来指定一个zone，中国:cn，海外地区:sg');
    }
    APP_ID = app_id;
    ACTIVITY_ID = activity_id;
    DEFAULT_DATA = default_data;
    AREA_SIGNAL = zone;
    startTime = new Date().getTime();
    HAS_INITED_APP_ID = true;
    HAS_INITED_ACTIVITY_ID = true;
    // 判断是否有tea sdk
    // if (!window.collectEvent && (!window.GameTool || !window.GameTool.collectEvent)) {
    //   console.log('***=== auto inject tea sdk  ===***')
    //   await preInstallTeaSdk(zone);
    // }
    console.log('***=== sendLogV3 inited ===***');
};
// 获取地理位置信息，只在正式环境有效
var getGeoCount = 0;
var getGeoInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, jsonData, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // 只获取三次
                if (getGeoCount >= 3) {
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, window.fetch((location.origin ||
                        '') + "/act/" + APP_ID + "/location/geonameids?activity_id=" + ACTIVITY_ID + "&type=1")];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 3:
                jsonData = _a.sent();
                if (jsonData.data) {
                    geoInfo = jsonData.data;
                }
                return [3 /*break*/, 5];
            case 4:
                e_1 = _a.sent();
                return [3 /*break*/, 5];
            case 5:
                getGeoCount += 1;
                return [2 /*return*/];
        }
    });
}); };
var timeGroups = {};
export var sendLogV3 = function (event, params, group_data, beconEvent) {
    if (params === void 0) { params = {}; }
    if (group_data === void 0) { group_data = { name: "", type: 1 }; }
    if (beconEvent === void 0) { beconEvent = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var collectEvent, environment, duration_json, open_id, role_id, device_id, server_id, from_source, token, scenese, actForms, _params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!HAS_INITED_APP_ID || !HAS_INITED_ACTIVITY_ID) {
                        throw new Error("\n      \u8BF7\u5148\u8C03\u7528gameSDK.Tea.initSendLogV3\u65B9\u6CD5\u521D\u59CB\u5316app_id\u548Cactivity_id.\n      \u4F8B\u5982:\n        gameSDK.Tea.initSendLogV3({app_id: 1781, activity_id: 123});\n      \u6CE8\u610F: app_id\u548Cactivity_id\u53EF\u8BE2\u95EE\u76F8\u5173\u5BF9\u63A5\u4EBA\u83B7\u53D6\u3002\n    ");
                    }
                    if (!(!HAS_FETCHED_GEO && !HAS_START_FETCH_GEO)) return [3 /*break*/, 2];
                    HAS_START_FETCH_GEO = true;
                    return [4 /*yield*/, getGeoInfo()];
                case 1:
                    _a.sent();
                    HAS_FETCHED_GEO = true;
                    _a.label = 2;
                case 2:
                    collectEvent = window.collectEvent || defaultLogMessageFn;
                    // 设置header
                    if (!HAS_CONFIG_CUS_HEADER) {
                        environment = getCustomsHeader();
                        HAS_CONFIG_CUS_HEADER = true;
                        collectEvent('config', {
                            environment: environment,
                        });
                    }
                    duration_json = {};
                    if (group_data.name) {
                        if (group_data.type === 2 && timeGroups[group_data.name]) {
                            duration_json["duration"] = new Date().getTime() - timeGroups[group_data.name];
                        }
                        else {
                            timeGroups[group_data.name] = new Date().getTime();
                        }
                    }
                    open_id = QUERY.open_id, role_id = QUERY.role_id, device_id = QUERY.device_id, server_id = QUERY.server_id, from_source = QUERY.from_source, token = QUERY.token;
                    scenese = /BDGameSDK/i.test(navigator.userAgent);
                    if (!!window.runtime) {
                        actForms = window.runtime.actForms;
                    }
                    if (!LAUNCH_FROM) {
                        LAUNCH_FROM = getAppType();
                    }
                    if (!OS) {
                        OS = getOS();
                    }
                    _params = __assign(__assign(__assign(__assign({ aid: String(APP_ID), user_unique_id: open_id || BE_NULL, role_id: role_id || BE_NULL, device_id: device_id || BE_NULL, os: OS, launch_from: LAUNCH_FROM || BE_NULL, launch_way: BE_NULL, server_id: server_id ? +server_id : BE_NULL, activity_type: '2', activity_id: String(ACTIVITY_ID), activity_link_id: from_source || BE_NULL, is_share: token ? location.href : BE_NULL, scenese: scenese ? '2' : '1', event_id: EVENT_ID, session_id: getSessionId(), timestamp: String(Date.now()), activity_form: (actForms || []).join(',') || BE_NULL, params_for_special: AREA_SIGNAL === 'cn' ? 'xuanwu' : 'xuanwu_overseas', url: location.href, page_id: location.origin + location.pathname, refer_url: document.referrer || BE_NULL }, duration_json), DEFAULT_DATA), geoInfo), params);
                    if (beconEvent) {
                        return [2 /*return*/, collectEvent('beconEvent', event, _params)];
                    }
                    return [2 /*return*/, collectEvent(event, _params)];
            }
        });
    });
};
//# sourceMappingURL=index.js.map